import dataLayerSearch from 'assets/core/js/module/searchForm/dataLayer/search'
import searchAround from 'assets/core/js/module/searchForm/searchAround'
import selects from 'assets/core/js/module/searchForm/selects'
import autocomplete from 'assets/themes/campings/js/module/searchForm/autocomplete'
import calendar from 'assets/themes/campings/js/module/searchForm/calendar'
import events from 'assets/themes/campings/js/module/searchForm/events'
import menus from 'assets/themes/campings/js/module/searchForm/menus'
import travelerSelector from 'assets/themes/campings/js/module/searchForm/travelerSelector'

export default function (): void {
  const calendarInstance = calendar()
  const autocompleteInstance = autocomplete()
  selects()
  events()
  menus()
  searchAround()
  const travelerSelectorInstance = travelerSelector()
  let capacityInstance: HTMLSelectElement | undefined
  // When the traveler selector is enabled, the capacity is not a select.
  if (!travelerSelectorInstance) {
    capacityInstance = (document.getElementById('search_offers_capacity') as HTMLSelectElement | null) ?? undefined
  }

  dataLayerSearch(autocompleteInstance, calendarInstance, travelerSelectorInstance, capacityInstance)
}
